import React, { useState } from 'react';
import { Box, Typography, IconButton } from '@mui/material';
import { ReactComponent as DeleteIcon } from '../../../assets/SVG/trash.svg';
import EmbryoImageLightbox from '../../../pages/Embryology/Embryo_Culture/EmbryoImageLightbox';
import PictureAsPdfIcon from '@mui/icons-material/PictureAsPdf';
import Tooltip from '@mui/material/Tooltip';
import VisibilityIcon from '@mui/icons-material/Visibility';
interface UploadedImage {
    name: string;
    image: string;
    size?: string; 
  }

interface ImageItemProps {
  image: UploadedImage;
  index: number;
  onRemove: (index: number) => void;
}

const ImageItem: React.FC<ImageItemProps> = ({ image, index, onRemove }) => {
  const [open, setOpen] = useState(false);

  const isPdf = image.name.toLowerCase().endsWith('.pdf');

  const openPdf = (base64: string) => {
    const byteCharacters = atob(base64.split(',')[1]);
    const byteNumbers = new Array(byteCharacters.length).fill(0).map((_, i) => byteCharacters.charCodeAt(i));
    const byteArray = new Uint8Array(byteNumbers);
    const blob = new Blob([byteArray], { type: 'application/pdf' });
    const blobUrl = URL.createObjectURL(blob);
    window.open(blobUrl, '_blank');
  };

  const MAX_NAME_LENGTH = 150;

  const truncateName = (name: string, maxLength: number) =>
    name.length > maxLength ? name.slice(0, maxLength) + '...' : name;


  return (
    <Box
      key={index}
      sx={{
        display: 'flex',
        alignItems: 'center',
        backgroundColor: '#F9F9F9',
        borderRadius: 2,
        p: 1.5,
        border: '1px solid #E0E0E0'
      }}
    >
        
      {isPdf ? (
        <>
          <PictureAsPdfIcon sx={{ fontSize: 30, color: 'red', marginRight: 1 }} onClick={() => openPdf(image.image)} />         
        </>
      ) : (
        <img
          src={image.image}
          style={{ width: 30, height: 30, borderRadius: 8, objectFit: 'cover', marginRight: 8, cursor: 'pointer'}}
          onClick={() => setOpen(true)}
          alt="Thumbnail"
        />
      )}    
      <Tooltip title={image.name}>
        <Typography sx={{ flexGrow: 1, fontSize: '14px', color: '#333', overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap', maxWidth: 400 }}>
          {truncateName(image.name, MAX_NAME_LENGTH)}
        </Typography>
      </Tooltip>
      <Typography sx={{ fontSize: '12px', color: '#999', mr: 1, width:'60px' }}> {image.size} MB</Typography>
      {isPdf ? (
        <>
          <IconButton onClick={() => openPdf(image.image)}  title="View PDF" >
            <VisibilityIcon />
          </IconButton>
        </>
      ) : (
        <IconButton onClick={() => setOpen(true)}  title="View PDF" >
          <VisibilityIcon />
        </IconButton>
      )}
      <IconButton size="small" onClick={() => onRemove(index)}>
        <DeleteIcon fontSize="small" color="error" />
      </IconButton>

      {open && (
        <EmbryoImageLightbox
          imageUrl={image.image}
          embryoNumber = {'#'+index}
          onClose={() => setOpen(false)}
          label={'Image'}
        />
      )}
    </Box>
  );
};

export default ImageItem;
